import styled from 'styled-components';

export const TooltipMenuStyle = styled.div`
  .tooltipMenu {
    border: 1px solid ${props => props.theme.grayUltraUltraLight} !important;
    opacity: 1 !important;
    &.place-top {
      margin-top: 0 !important;
      &:before {
        border-top: 8px solid ${props => props.theme.grayUltraUltraLight} !important;
      }
    }
    &.place-bottom {
      margin-top: 0 !important;
      &:before {
        border-bottom: 8px solid ${props => props.theme.grayUltraUltraLight} !important;
      }
    }
    &.place-left {
      margin-left: 0 !important;
      &:before {
        border-left: 8px solid ${props => props.theme.grayUltraUltraLight} !important;
      }
    }
    &.place-right {
      margin-left: 0 !important;
      &:before {
        border-right: 8px solid ${props => props.theme.grayUltraUltraLight} !important;
      }
    }
  
    &__itemsContainer {
      text-align: left;
    }
  
    &__item {
      display: block;
      margin: 2px;
      cursor: pointer;
      color: ${props => props.theme.brand};
      font-size: 15px;
      &:hover{
        color: ${props => props.theme.brandOver};
      }
      &.campaignName{
        cursor: inherit;
        border-bottom: 1px solid ${props => props.theme.grayUltraUltraLight};
        margin-top: 10px;
        color: ${props => props.theme.textColorDark};
        &:hover {
          color:  ${props => props.theme.textColorDark};
        }
      }
    }
  }
`;